export default __webpack_public_path__ + "static/media/Guild_banner.c7843117.png";